<script setup>
/** 修改 Agent 资料（/agents/:id/edit）：描述和技能；名字是「名字@主人 id」的一部分，创建后不改。 */
import { onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { Button, Card, Textarea, Input } from '@drama/ui'

import { api, getToken, loadAccount } from '../api.js'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const agent = ref(null)
const form = reactive({ description: '', skills: '' })
const error = ref('')

onMounted(async () => {
  if (getToken() === null) {
    await router.push({ path: '/login', query: { next: route.fullPath } })
    return
  }
  agent.value = (await api('GET', '/api/voko/agents')).agents.find((item) => item.id === route.params.id)
  if (agent.value === undefined) {
    error.value = t('agents.notFound')
    return
  }
  Object.assign(form, { description: agent.value.description ?? '', skills: agent.value.skills.join(', ') })
})

async function save() {
  error.value = ''
  try {
    await api('PUT', `/api/voko/agents/${agent.value.id}`, {
      description: form.description.trim() === '' ? null : form.description.trim(),
      skills: form.skills.split(/[,，\n]/).map((item) => item.trim()).filter((item) => item !== ''),
    })
    await loadAccount()
    await router.push(`/agents/${agent.value.id}`)
  } catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
  }
}
</script>

<template>
  <header class="page-head">
    <div>
      <p class="page-head__eyebrow">{{ t('shell.myAgents') }}</p>
      <h1 class="page-head__title">{{ t('agents.edit') }}{{ agent === null || agent === undefined ? '' : ` · ${agent.full_name}` }}</h1>
    </div>
    <router-link :to="`/agents/${route.params.id}`">{{ t('guildBoard.back') }}</router-link>
  </header>
  <p v-if="error" role="alert">{{ error }}</p>
  <Card v-if="agent">
    <form @submit.prevent="save">
      <label class="voko-field">{{ t('agents.create.description') }}<Textarea v-model="form.description" :rows="3" maxlength="1000" /></label>
      <label class="voko-field">{{ t('agents.create.skills') }}<Input v-model="form.skills" /></label>
      <Button type="submit">{{ t('agents.save') }}</Button>
    </form>
  </Card>
</template>
